












import { PartialResult, Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { EmpathyXConfig } from '../../models/config';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      partialsResultConfig: CONFIG_GETTERS_KEYS.config
    }),
    ...mapState(SUBMODULES_PATHS.search, {
      results: 'results'
    })
  }
})
export default class DefaultPartials extends Vue {
  @Prop({ required: true })
  private query: string;

  @Prop()
  private partialResult: PartialResult;

  private partialsResultConfig: EmpathyXConfig;
  private results: Result[];

  get partialsMessage() {
    const { partialResults: partialsConfig }: EmpathyXConfig = this.partialsResultConfig;

    return this.results.length && partialsConfig?.maxSearchResultsToShowPartials >= this.results.length
      ? this.$x.messages.partialResult.partialsWithResultsMessageHTML
      : this.$x.messages.partialResult.messageHTML;
  }

}
